import { Flex } from '@instructure/ui-flex'

import { IconMasteryLogo } from '../../../../mc-icons/svg'
export const Header = () => {
  return (
    <>
      <Flex margin="none none large none">
        <Flex.Item shouldGrow margin="none x-large none none">
          <IconMasteryLogo size="large" color="primary-inverse" />
        </Flex.Item>
      </Flex>
    </>
  )
}